export default {
	rpc: {},
	types: {
		EthWalletCall: {
			nonce: "u32",
		},
	},
};
